import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function ListaPCA() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem('UserRole');
    setIsAdmin(userRole === 'admin');
    fetchData();
  }, []);

  const fetchData = () => {
    axios
      .get('/api/pca')
      .then((res) => {
        setData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filtered = data.filter(
      (item) =>
        item.requisitante.toLowerCase().includes(searchTerm) ||
        item.objeto.toLowerCase().includes(searchTerm)
    );
    setFilteredData(filtered);
  };

  const handleDelete = (id) => {
    if (window.confirm('Deseja realmente deletar este PCA?')) {
      axios
        .delete(`/api/pca/${id}`)
        .then((res) => {
          alert(res.data.message);
          // Atualiza a lista depois de deletar
          fetchData();
        })
        .catch((err) => {
          console.error(err);
          alert('Erro ao deletar PCA');
        });
    }
  };

  return (
    <div className="px-5 py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="m-0">Lista de PCA</h3>
        {isAdmin && (
          <Link to="/addpca" className="btn btn-success">
            Adicionar PCA
          </Link>
        )}
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Pesquisar por requisitante ou objeto..."
          onChange={handleSearch}
        />
      </div>

      <div className="table-responsive">
        <table className="table table-striped tabela-pequena">
          <thead>
            <tr>
              <th>ID</th>
              <th>Requisitante</th>
              <th>Objeto</th>
              <th>Justificativa</th>
              <th>Valor</th>
              <th>Data Pretendida</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((pca) => (
              <tr key={pca.id}>
                <td>{pca.id}</td>
                <td>{pca.requisitante}</td>
                <td>{pca.objeto}</td>
                <td>{pca.justificativa}</td>
                <td>{pca.valor_preliminar}</td>
                <td>{pca.data_pretendida}</td>
                <td>
                  <Link
                    to={`/viewpca/${pca.id}`}
                    className="btn btn-warning btn-sm me-2"
                  >
                    Ver
                  </Link>
                  {isAdmin && (
                    <>
                      <Link
                        to={`/editpca/${pca.id}`}
                        className="btn btn-primary btn-sm me-2"
                      >
                        Editar
                      </Link>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(pca.id)}
                      >
                        Deletar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListaPCA;
